var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24254 3.93422L7.08906 3.65152C5.7914 3.32171 4.75808 2.26159 4.51778 0.965886L4.34956 0.141349C4.34956 0.141349 4.32553 0 4.18134 0C4.03716 0 4.01313 0.141349 4.01313 0.141349L3.84491 0.989444C3.58058 2.28515 2.57129 3.34526 1.27363 3.67508L0.120154 3.95778C0.120154 3.95778 0 3.98134 0 4.12268C0 4.26403 0.120154 4.28759 0.120154 4.28759L1.27363 4.57029C2.57129 4.90011 3.58058 5.96023 3.84491 7.27948L4.03716 8.26893C4.03716 8.26893 4.06119 8.38672 4.20538 8.38672C4.34956 8.38672 4.37359 8.26893 4.37359 8.26893L4.56584 7.27948C4.80614 5.98378 5.81543 4.92366 7.13712 4.57029L8.26657 4.28759C8.26657 4.28759 8.38672 4.26403 8.38672 4.12268C8.38672 3.98134 8.26657 3.95778 8.26657 3.95778L8.24254 3.93422Z",
    fill: "#00A189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointVector);
export default __webpack_public_path__ + "static/media/point-vector.b6a7251bd24851d678ff35354710a099.svg";
export { ForwardRef as ReactComponent };